import { render, staticRenderFns } from "./personalMall.vue?vue&type=template&id=24aeb8d1"
import script from "./personalMall.vue?vue&type=script&lang=js"
export * from "./personalMall.vue?vue&type=script&lang=js"
import style0 from "./personalMall.vue?vue&type=style&index=0&id=24aeb8d1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports